import React, { Component } from 'react';
import { Field } from 'react-final-form';
import InputField from '../../../components/InputField';
import DescriptionField from '../../../components/DescriptionField';
import Validators, { required } from '../../../Common/validators';
import { normalizeBarcode } from '../../../Common/normalize';

class ZwalletPaymentFormStep1 extends Component {
  render() {
    const { handleSubmit, invalid } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="pl-lg-4">
          <div className="row">
            <div className="col-12 col-md-12">
              <Field
                name="barcode"
                type="text"
                className="form-control"
                label="Código de Barra"
                placeholder="XXXXX.XXXXX XXXXX.XXXXXX XXXXX.XXXXX X XXXXXXXXXXXXXXXX"
                parse={normalizeBarcode}
                validate={Validators(required)}
                component={InputField}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-12">
              <Field
                label="Descrição"
                className="form-control"
                name="description"
                component={DescriptionField}
              />
            </div>
          </div>
        </div>
        <div className="text-center">
          <button
            type="submit"
            className="btn btn-success mt-4"
            disabled={invalid}>
            Próximo
          </button>
        </div>
      </form>
    );
  }
}

export default ZwalletPaymentFormStep1;


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/components/Form1.js